import "core-js/modules/es.array.from.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/web.dom-collections.for-each.js";
import { reactive, ref } from "vue";
import VueEasyLightbox from "vue-easy-lightbox";
export default {
  name: "KilaKilaLightBox",
  components: {
    VueEasyLightbox: VueEasyLightbox
  },
  props: {
    container: {
      type: String,
      default: ".post-body .article-content"
    }
  },
  setup: function setup(props) {
    var isVisible = ref(false);
    var images = reactive(getImages());
    var index = ref(0);

    function getImages() {
      var images = [];
      var articleElement = document.querySelector(props.container);
      if (!articleElement) return images; // 获取所有图片

      var imageElements = Array.from(articleElement.querySelectorAll("img"));

      for (var _i = 0, _imageElements = imageElements; _i < _imageElements.length; _i++) {
        var imageElement = _imageElements[_i];
        var src = imageElement.src;
        var title = imageElement.title || "";
        var alt = imageElement.alt || "";
        images.push({
          title: title,
          src: src,
          alt: alt
        });
      }

      return images;
    }

    function addImageClickedListener() {
      var imageElements = Array.from(document.querySelectorAll(props.container + " img"));
      imageElements.forEach(function (imageElement, i) {
        imageElement.addEventListener("click", function () {
          index.value = i;
          show();
        });
      });
    }

    function show() {
      isVisible.value = true;
    }

    function handleHide() {
      isVisible.value = false;
    }

    return {
      images: images,
      isVisible: isVisible,
      index: index,
      handleHide: handleHide,
      show: show,
      addImageClickedListener: addImageClickedListener
    };
  }
};